package com.eladfinish.bible.contest.network

object GithubURL {
    const val BASE_URL = "https://raw.githubusercontent.com"

    private const val NUMBER_PATH = "/elfifo4/numbers-in-bible/master/minified/"
    private const val ROOT_PATH = "/elfifo4/roots-in-bible/master/minified/"
    private const val NAME_PATH = "/elfifo4/names-in-bible/main/"
    private const val DATE_PATH = "/elfifo4/dates-in-bible/master/minified/"
    const val NUM = "num"
    const val LETTER = "letter"
    const val ROOT = "root"
    private const val JSON = "json"

    fun numberUrl(number: Int): String = "$BASE_URL$NUMBER_PATH$number.$JSON"

    fun rootUrl(letter: String, root: String): String =
        "$BASE_URL$ROOT_PATH${letter.encodeUrlPathPart()}/${root.encodeUrlPathPart()}.$JSON"

    /** Months are counted from Nisan (1) as in the Bible; 404 when no verse has this date. */
    fun dateUrl(month: Int, day: Int): String = "$BASE_URL$DATE_PATH$month/$day.$JSON"

    fun dateMonthUrl(month: Int): String = "$BASE_URL$DATE_PATH$month/all.$JSON"

    /** [cacheBuster] (e.g. the current time) bypasses raw.githubusercontent's caching of the names data. */
    fun nameUrl(gender: String, letter: String, cacheBuster: Long): String =
        "$BASE_URL$NAME_PATH$gender/${letter.encodeUrlPathPart()}/all.$JSON?$cacheBuster"

    /** GitHub API listing of [numberUrl]'s directory — the numbers that have data. */
    const val NUMBERS_LISTING_URL = "https://api.github.com/repos/elfifo4/numbers-in-bible/contents/minified"

    // Hebrew path segments must be percent-encoded: Ktor's CIO engine (used on desktop) sends
    // non-ASCII path segments as raw UTF-8 bytes and the server rejects the request with
    // 400 Bad Request, where OkHttp/Darwin (Android/iOS) re-encode them themselves.
    private fun String.encodeUrlPathPart(): String = buildString {
        for (byte in this@encodeUrlPathPart.encodeToByteArray()) {
            val char = byte.toInt().toChar()
            if (byte >= 0 && (char.isLetterOrDigit() || char in "-._~")) {
                append(char)
            } else {
                append('%')
                append(HEX[(byte.toInt() shr 4) and 0xF])
                append(HEX[byte.toInt() and 0xF])
            }
        }
    }

    private const val HEX = "0123456789ABCDEF"

}
